<template>
  <div>
    <div class="register-confirm">
      <div class="grayHead">
        <span>
          アカウントが登録されました。
        </span>
      </div>
      <div class="register-confirm__btnWrapper">
        <Btn
          :label="'戻る'"
          :color="'red'"
          class="edit-btn"
          @click.native="back"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import store from '@/store'
import error from '@/mixin/error.mixin'
import redirect from '@/mixin/redirect.mixin'
import Btn from '@/components/parts/Btn'

export default {
  name: 'AccountCreateStep05Complete',

  mixins: [error, redirect],

  components: {
    Btn
  },

  computed: {
    ...mapGetters('accountCreate', ['form', 'user'])
  },

  beforeRouteEnter (from, to, next) {
    store.commit('loadingAction', false)
    next()
  },

  methods: {
    async back () {
      await store.commit('loadingAction', true)
      await store.dispatch('auth/login', {
        mail: this.user.mail,
        password: this.form.login_password
      }).then(() => {
        this.goToEcSite()
      }).catch(() => {
        store.commit('loadingAction', false)
        this.$router.push({ name: 'Error401' })
      }).finally(() => {
        store.commit('accountCreate/clear')
      })
    }
  }
}
</script>

<style lang="postcss" scoped>

  .register-confirm {
    height: 100%;
    overflow: auto;

    &__btnWrapper {
      margin: 100px auto 40px;
      padding: 0 15px;
      max-width: 600px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/account-create/Step05Complete.vue